// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HeroSection.css - Hero区域和FilmStrip样式 */

/* ===== Hero区域 ===== */
.hero-viewport {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
}

.hero-text {
  text-align: center;
  margin-bottom: 25px;
}

/* 中文标题样式 */
.hero-text-zh h1 {
  font-family: 'Orbitron';
  font-size: clamp(1.8rem, 4vw, 3.2rem);
  margin-bottom: 15px;
  background: linear-gradient(
    to right,
    #ffffff 0%,
    #a8d8ff 25%,
    #7e57ff 50%,
    #00e5ff 75%,
    #ffffff 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  background-size: 200% auto;
  animation: gradientText 4s linear infinite;
  text-shadow:
    0 2px 10px rgba(0, 0, 0, 0.3),
    0 4px 20px rgba(0, 0, 0, 0.2);
}

/* 英文标题样式 */
.hero-text-en h1 {
  font-family: 'Orbitron';
  font-size: clamp(1.5rem, 3.5vw, 2.8rem);
  margin-bottom: 12px;
  background: linear-gradient(
    to right,
    #ffffff 0%,
    #a8d8ff 25%,
    #7e57ff 50%,
    #00e5ff 75%,
    #ffffff 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  background-size: 200% auto;
  animation: gradientText 4s linear infinite;
  text-shadow:
    0 2px 10px rgba(0, 0, 0, 0.3),
    0 4px 20px rgba(0, 0, 0, 0.2);
}

@keyframes gradientText {
  0% { background-position: 200% center; }
  100% { background-position: -200% center; }
}

/* 中文副标题样式 */
.hero-text-zh p {
  color: var(--primary);
  font-size: 1rem;
  letter-spacing: 4px;
  font-weight: 400;
  text-shadow: 0 0 8px rgba(0, 229, 255, 0.3);
}

/* 英文副标题样式 */
.hero-text-en p {
  color: var(--primary);
  font-size: 0.9rem;
  letter-spacing: 2px;
  font-weight: 400;
  text-shadow: 0 0 8px rgba(0, 229, 255, 0.3);
}

/* ===== 电影胶片样式 ===== */
.film-strip-container {
  width: 100%;
  position: relative;
  margin-bottom: 35px;
  background: linear-gradient(to bottom, #000 0%, #111 50%, #000 100%);
  padding: 5px 0;
  border-top: 1px solid rgba(0, 229, 255, 0.2);
  border-bottom: 1px solid rgba(0, 229, 255, 0.2);
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.7),
    inset 0 0 30px rgba(0, 0, 0, 0.5);
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 胶片孔效果 */
.film-strip-container::before,
.film-strip-container::after {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 10px;
  background-image:
    linear-gradient(to right,
      transparent 0%,
      transparent 5%,
      rgba(0, 229, 255, 0.3) 6%,
      rgba(0, 229, 255, 0.3) 7%,
      transparent 8%,
      transparent 93%,
      rgba(0, 229, 255, 0.3) 94%,
      rgba(0, 229, 255, 0.3) 95%,
      transparent 96%,
      transparent 100%
    ),
    repeating-linear-gradient(
      90deg,
      transparent,
      transparent 24px,
      rgba(42, 53, 79, 0.8) 24px,
      rgba(42, 53, 79, 0.8) 48px
    );
  background-size: 100% 100%, 48px 10px;
  z-index: 1;
  pointer-events: none;
}

.film-strip-container::before {
  top: 0;
}

.film-strip-container::after {
  bottom: 0;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    inset 0 -1px 0 rgba(255, 255, 255, 0.1);
}

/* 胶片轨道动画 */
.gallery-track {
  display: flex;
  gap: 8px;
  width: max-content;
  animation: scroll 40s linear infinite;
  position: relative;
  z-index: 2;
  padding: 10px 0;
}

@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-250px * 6)); }
}

/* 故事卡片 */
.story-card {
  width: 240px;
  height: 135px;
  flex-shrink: 0;
  background-size: cover;
  background-position: center;
  position: relative;
  filter: brightness(0.9) saturate(0.95);
  transition: all 0.4s cubic-bezier(0.2, 1, 0.3, 1);
  border-left: 3px solid #000;
  border-right: 3px solid #000;
  overflow: hidden;
  z-index: 2;
}

.story-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid rgba(0, 229, 255, 0.2);
  pointer-events: none;
  z-index: 1;
}

.story-card:hover {
  filter: brightness(1.15) saturate(1.1);
  transform: scale(1.05);
  z-index: 12;
  box-shadow:
    0 5px 20px rgba(0, 229, 255, 0.3),
    0 0 30px rgba(126, 87, 255, 0.2);
}

.story-card span {
  position: absolute;
  bottom: 10px;
  left: 12px;
  font-size: 0.7rem;
  color: #fff;
  font-family: 'Orbitron';
  background: linear-gradient(90deg,
    rgba(0, 229, 255, 0.4),
    rgba(126, 87, 255, 0.4));
  backdrop-filter: blur(8px);
  padding: 4px 10px;
  border-radius: 3px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  letter-spacing: 1px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-viewport {
    padding-top: 30px;
  }

  .story-card {
    width: 180px;
    height: 101px;
  }

  @keyframes scroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(calc(-188px * 6)); }
  }
}

@media (max-width: 480px) {
  .hero-text-zh h1,
  .hero-text-en h1 {
    font-size: clamp(1.2rem, 5vw, 1.8rem);
  }

  .story-card {
    width: 140px;
    height: 79px;
  }

  .story-card span {
    font-size: 0.6rem;
    padding: 2px 6px;
  }

  @keyframes scroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(calc(-148px * 6)); }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HeroSection.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC,uBAAuB;AACvB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB;;;;;;;GAOC;EACD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,0CAA0C;EAC1C;;iCAE+B;AACjC;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,uCAAuC;EACvC,mBAAmB;EACnB;;;;;;;GAOC;EACD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,0CAA0C;EAC1C;;iCAE+B;AACjC;;AAEA;EACE,KAAK,gCAAgC,EAAE;EACvC,OAAO,iCAAiC,EAAE;AAC5C;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oEAAoE;EACpE,cAAc;EACd,4CAA4C;EAC5C,+CAA+C;EAC/C;;qCAEmC;EACnC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,UAAU;AACV;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;;;;;;;;;;;;;;KAmBG;EACH,qCAAqC;EACrC,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;EACT;;2CAEyC;AAC3C;;AAEA,WAAW;AACX;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,uCAAuC,EAAE;AAClD;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,sCAAsC;EACtC,iDAAiD;EACjD,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,WAAW;EACX;;oCAEkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB;;4BAE0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,KAAK,wBAAwB,EAAE;IAC/B,OAAO,uCAAuC,EAAE;EAClD;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,KAAK,wBAAwB,EAAE;IAC/B,OAAO,uCAAuC,EAAE;EAClD;AACF","sourcesContent":["/* HeroSection.css - Hero区域和FilmStrip样式 */\n\n/* ===== Hero区域 ===== */\n.hero-viewport {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-top: 40px;\n}\n\n.hero-text {\n  text-align: center;\n  margin-bottom: 25px;\n}\n\n/* 中文标题样式 */\n.hero-text-zh h1 {\n  font-family: 'Orbitron';\n  font-size: clamp(1.8rem, 4vw, 3.2rem);\n  margin-bottom: 15px;\n  background: linear-gradient(\n    to right,\n    #ffffff 0%,\n    #a8d8ff 25%,\n    #7e57ff 50%,\n    #00e5ff 75%,\n    #ffffff 100%\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  background-size: 200% auto;\n  animation: gradientText 4s linear infinite;\n  text-shadow:\n    0 2px 10px rgba(0, 0, 0, 0.3),\n    0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n/* 英文标题样式 */\n.hero-text-en h1 {\n  font-family: 'Orbitron';\n  font-size: clamp(1.5rem, 3.5vw, 2.8rem);\n  margin-bottom: 12px;\n  background: linear-gradient(\n    to right,\n    #ffffff 0%,\n    #a8d8ff 25%,\n    #7e57ff 50%,\n    #00e5ff 75%,\n    #ffffff 100%\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  background-size: 200% auto;\n  animation: gradientText 4s linear infinite;\n  text-shadow:\n    0 2px 10px rgba(0, 0, 0, 0.3),\n    0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n@keyframes gradientText {\n  0% { background-position: 200% center; }\n  100% { background-position: -200% center; }\n}\n\n/* 中文副标题样式 */\n.hero-text-zh p {\n  color: var(--primary);\n  font-size: 1rem;\n  letter-spacing: 4px;\n  font-weight: 400;\n  text-shadow: 0 0 8px rgba(0, 229, 255, 0.3);\n}\n\n/* 英文副标题样式 */\n.hero-text-en p {\n  color: var(--primary);\n  font-size: 0.9rem;\n  letter-spacing: 2px;\n  font-weight: 400;\n  text-shadow: 0 0 8px rgba(0, 229, 255, 0.3);\n}\n\n/* ===== 电影胶片样式 ===== */\n.film-strip-container {\n  width: 100%;\n  position: relative;\n  margin-bottom: 35px;\n  background: linear-gradient(to bottom, #000 0%, #111 50%, #000 100%);\n  padding: 5px 0;\n  border-top: 1px solid rgba(0, 229, 255, 0.2);\n  border-bottom: 1px solid rgba(0, 229, 255, 0.2);\n  box-shadow:\n    0 10px 30px rgba(0, 0, 0, 0.7),\n    inset 0 0 30px rgba(0, 0, 0, 0.5);\n  overflow: visible;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* 胶片孔效果 */\n.film-strip-container::before,\n.film-strip-container::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 10px;\n  background-image:\n    linear-gradient(to right,\n      transparent 0%,\n      transparent 5%,\n      rgba(0, 229, 255, 0.3) 6%,\n      rgba(0, 229, 255, 0.3) 7%,\n      transparent 8%,\n      transparent 93%,\n      rgba(0, 229, 255, 0.3) 94%,\n      rgba(0, 229, 255, 0.3) 95%,\n      transparent 96%,\n      transparent 100%\n    ),\n    repeating-linear-gradient(\n      90deg,\n      transparent,\n      transparent 24px,\n      rgba(42, 53, 79, 0.8) 24px,\n      rgba(42, 53, 79, 0.8) 48px\n    );\n  background-size: 100% 100%, 48px 10px;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.film-strip-container::before {\n  top: 0;\n}\n\n.film-strip-container::after {\n  bottom: 0;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.1),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.1);\n}\n\n/* 胶片轨道动画 */\n.gallery-track {\n  display: flex;\n  gap: 8px;\n  width: max-content;\n  animation: scroll 40s linear infinite;\n  position: relative;\n  z-index: 2;\n  padding: 10px 0;\n}\n\n@keyframes scroll {\n  0% { transform: translateX(0); }\n  100% { transform: translateX(calc(-250px * 6)); }\n}\n\n/* 故事卡片 */\n.story-card {\n  width: 240px;\n  height: 135px;\n  flex-shrink: 0;\n  background-size: cover;\n  background-position: center;\n  position: relative;\n  filter: brightness(0.9) saturate(0.95);\n  transition: all 0.4s cubic-bezier(0.2, 1, 0.3, 1);\n  border-left: 3px solid #000;\n  border-right: 3px solid #000;\n  overflow: hidden;\n  z-index: 2;\n}\n\n.story-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 1px solid rgba(0, 229, 255, 0.2);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.story-card:hover {\n  filter: brightness(1.15) saturate(1.1);\n  transform: scale(1.05);\n  z-index: 12;\n  box-shadow:\n    0 5px 20px rgba(0, 229, 255, 0.3),\n    0 0 30px rgba(126, 87, 255, 0.2);\n}\n\n.story-card span {\n  position: absolute;\n  bottom: 10px;\n  left: 12px;\n  font-size: 0.7rem;\n  color: #fff;\n  font-family: 'Orbitron';\n  background: linear-gradient(90deg,\n    rgba(0, 229, 255, 0.4),\n    rgba(126, 87, 255, 0.4));\n  backdrop-filter: blur(8px);\n  padding: 4px 10px;\n  border-radius: 3px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);\n  letter-spacing: 1px;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .hero-viewport {\n    padding-top: 30px;\n  }\n\n  .story-card {\n    width: 180px;\n    height: 101px;\n  }\n\n  @keyframes scroll {\n    0% { transform: translateX(0); }\n    100% { transform: translateX(calc(-188px * 6)); }\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-text-zh h1,\n  .hero-text-en h1 {\n    font-size: clamp(1.2rem, 5vw, 1.8rem);\n  }\n\n  .story-card {\n    width: 140px;\n    height: 79px;\n  }\n\n  .story-card span {\n    font-size: 0.6rem;\n    padding: 2px 6px;\n  }\n\n  @keyframes scroll {\n    0% { transform: translateX(0); }\n    100% { transform: translateX(calc(-148px * 6)); }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
